import { format, isToday, isYesterday } from "date-fns";
export var getFormattedDate = function (date) {
    return isToday(date) ? "Today" : isYesterday(date) ? "Yesterday" : format(date, "d MMM yyyy");
};
//# sourceMappingURL=getFormattedDate.js.map